<template>
	<div>
		<div class="row">
			<div class="col-md-12 p-0">
				<el-card class="box-card col-md-12 mb-1" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>Station List</strong></span>
					</div>
					<div>
						<el-collapse style="margin-top:-21px;">
                            <el-collapse-item>
                                <template slot="title">
                                    <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                                </template>
                                <el-form label-position="top" label-width="100px" class="ml-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <el-form-item label="Station:">
                                                <el-select v-model="stationid" clearable filterable placeholder="Select Station" size="medium" style="width:100%;">
                                                    <el-option v-for="item3 in spbu.list" :key="item3.BranchId" :label="item3.StationName" :value="item3.StationId">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                             
                                        <div class="col-md-12">
                                            <el-form-item label="Type">
                                                <el-radio-group v-model="stationtype" size="small" name="type">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                         
                                        <div class="col-md-6">
                                            <el-form-item label="Area">
                                                <el-radio-group v-model="area" size="small" name="area">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

										<div class="col-md-6">
                                            <el-form-item label="Region">
                                                <el-radio-group v-model="region" size="small" name="region">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6">
                                            <el-form-item label="Owner">
                                                <el-checkbox-group v-model="owners" size="small" name="owner">
                                                    <el-checkbox-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-checkbox-button>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </div>

										<div class="col-md-6">
                                            <el-form-item label="Status">
                                                <el-radio-group v-model="statusactive" size="small" name="status">
                                                    <el-radio-button :label="item8.value" v-for="(item8, index8) in options.status" :key="item8.value+'_'+index8" style="margin-left:0px;">{{item8.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-md-6">
                                            <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                                        </div>
                                    </div>

                                </el-form>
                            </el-collapse-item>
                        </el-collapse>
					</div>

                    <div class="row mt-2 mb-2">
                        <div class="col-md-6">
                            <!--<input type="checkbox" v-model="showmap"> Show Map--> 
                            <el-checkbox v-model="showmap">Show Map</el-checkbox>
                        </div>
                    </div> 

                    <PetaGmap v-if="showmap" :zoom="this.zoom" :centeringMap="centeringMap" :stationListMap="stationListMap" @pilihStationDariGmap="pilihStationDariGmap"/>
                    
               
                    <div class="mb-0" >
                        <BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
                        <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="h-100 d-flex align-items-center justify-content-center">
                                <ReportResultTable reportname="StationList" :reportdata="reportdata" :reporturl="urlRequestParams" select_url="/plant?station=" idcol="StationId" :loading="loading.table"/>
                                
                            </div>
                        </div>
                    </div>

				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
//import BaselineComparisonTab from '@/views/pages/BaselineComparisonTab.vue'
import PetaGmap from '@/components/map/gmap.vue'
import { Rainbow, FuelColor, AxiosWithJar, Config} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends: Fuel,
	components: { 
		//BaselineComparisonTab,
        ReportResultTable,
		PetaGmap,
		//Loader,
        LineChart,
		BarChart,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabList:[
				{label:'Station List', name: 'station_list', index: '0' },
			],

            //
            options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				region:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
					{ value: "6", name: "6" }, 
					{ value: "7", name: "7" }, 
				],
				types:[
					{ value: '', name: 'ALL' },
					{ value: 'SPBU', name: 'SPBU' },
					{ value: 'SPBG', name: 'SPBG' },
					{ value: 'PERTASHOP', name: 'PERTASHOP' },
					{ value: 'SPBU-T', name: 'SPBU-T' },
					{ value: 'SHELTER', name: 'SHELTER' },
                    { value: 'MODULAR', name: 'MODULAR' },
                    { value: 'SATGAS', name: 'SATGAS' },
				],
				owner:[
					//{ value: "", name: "ALL" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "active", name: "Active" }, 
					{ value: "inactive", name: "Not Active" }, 
				],
			},
            //tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : '',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
            owners: ['COCO'],
			statusactive: 'active',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			showmap:false,

            charttype: 'linechart', //barchart //linechart
			chartdata: [],
			showchart: false,
			stacked: true,

            urlRequestParams: '',
			reportdata:[],
			stationListMap:[],
			centeringMap:{},
			zoom:5, 
		}
	},
	watch:
	{
		//stationtype(){ this.resumePilihan() },
		//stationid() { this.resumePilihan() },
        //owner() { this.resumePilihan() },
        //area() { this.resumePilihan() },

       
		//stacked() { this.refreshChart(); },
		//showtype() { this.refreshChart(); },

		reportdata(){
            //this.refreshChart();

			this.stationListMap = this.reportdata["data"]
				.filter(e=> e.Latitude!==null && e.Longitude!==null)
				.map(item=>Object.assign(item,
					{id:item.StationId,name:item.StationName,lat:Number(item.Latitude.replace(',','.')),lng:Number(item.Longitude.replace(',','.'))}))
		
			//console.log('this.stationListMap ' + JSON.stringify(this.stationListMap))
		},
		stationtype() {
			if(this.stationtype == 'SATGAS') {
				this.statusactive = 'inactive';
			} else {
				this.statusactive = 'active';
			}
		}
	}, 
    mounted()
    {
        this.$emit('childrenRoute')
        this.loadStationList()
		this.loadStationTypes()
		this.resumePilihan()
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

        //
        pilihStationDariGmap(stationId,PlantNo) {
            this.$router.push({ path: '/plant', query: { plant: PlantNo ,station: stationId } })
            location.reload()
        },

        refreshChart(){
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""
			
			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a
			
			let b = "OwnershipType"
			let c = (a == "ProductName") ? FuelColor : Rainbow

			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesArea", false, b, "", 1, 2, c, false, false, false, this.stacked);		
		},

        async resumePilihan() {
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/fuel2/station?'

			this.urlRequestParams+='&type='+this.stationtype
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&owner='+this.owner
            this.urlRequestParams+='&owners='+this.owners
			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&status='+this.statusactive

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
                    //console.log('this.reportdata["data"]' + JSON.stringify(this.reportdata["data"]))
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        applyFilter() {
			this.resumePilihan()
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>